import React from "react";
import PropTypes from "prop-types";
import {inject, observer} from "mobx-react";

import {OffersLoading} from "../../../prequal/offers/offers-interstitials";
import {pushApplicationFlow} from "../../../utils/gtm-utils";

const MAXIMUM_NUMBER_OF_ATTEMPTS = 50;

const responseOrStatusIsInvalid = (status, response) => {
    return status >= 400 || !response || !response.step_name;
};

export const DigitalCreditAppDecisioning = inject("apiStore")(
    observer(
        class _DigitalCreditAppDecisioning extends React.Component {
            static propTypes = {
                applicationUuid: PropTypes.string,
                flowStore: PropTypes.object.isRequired,
            };

            constructor(props) {
                super(props);
                this._unmounted = false;
            }

            componentWillUnmount() {
                this._unmounted = true;
            }

            componentDidMount() {
                const {applicationUuid, flowStore, apiStore} = this.props;

                if (!applicationUuid) {
                    flowStore.handleStepRedirection("error");
                    return;
                }

                pushApplicationFlow(applicationUuid, "decisioning");

                const endpoint = `/api/v2/applications/${applicationUuid}/`;

                let attempt = 1;
                const shouldContinue = (status, response) => {
                    if (responseOrStatusIsInvalid(status, response)) {
                        return false;
                    }
                    if (["done", "error"].includes(response.step_name)) {
                        return false;
                    }
                    if (attempt >= MAXIMUM_NUMBER_OF_ATTEMPTS) {
                        console.error(
                            `Failed to get decision for ${endpoint} after ${attempt} attempts`,
                        );
                        return false;
                    }
                    attempt += 1;
                    return true;
                };

                apiStore
                    .pollUrl(endpoint, shouldContinue, 5000)
                    .then(({response}) => {
                        if (this._unmounted) {
                            return;
                        }
                        const step =
                            response &&
                            ["done", "error"].includes(response.step_name)
                                ? response.step_name
                                : "error";
                        flowStore.handleStepRedirection(step);
                    })
                    .catch(() => {
                        if (this._unmounted) {
                            return;
                        }
                        flowStore.handleStepRedirection("error");
                    });
            }

            render() {
                return (
                    <OffersLoading
                        showTransparentOffers={false}
                        subcopy={<>We're checking across all of our programs to <br/>find the best fit for you</>}
                    />
               );
            }
        },
    ),
);
